// extracted by mini-css-extract-plugin
export default {"cta":"notifications-page_cta__m8uAc"};